import { useLoggedInUser } from "@/shared/queries/CurrentUser.tsx";
import { useIsProposalAssistantEnabled } from "@/shared/queries/aiSettings.ts";

export const useCanUseAiProposals = () => {
  const proposalAssistantEnabled = useIsProposalAssistantEnabled();
  const { isBidmanager, isInternationalmanager } = useLoggedInUser();

  return proposalAssistantEnabled && (isBidmanager || isInternationalmanager);
};
